var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-group', {
    staticClass: "product-family-compatibility-requirement-alternatives-manager",
    attrs: {
      "errors": _vm.internalErrors,
      "label": _vm.label
    }
  }, [_vm._l((_vm.alternatives), function(alternative, index) {
    return _c('div', {
      key: index,
      staticClass: "product-family-compatibility-requirement-alternatives-manager__group"
    }, [_c('div', {
      staticClass: "uk-margin-small uk-grid-column-small",
      attrs: {
        "uk-grid": ""
      }
    }, [_c('div', {
      staticClass: "uk-width-expand"
    }, [_c('product-family-combobox', {
      ref: "familySelectors",
      refInFor: true,
      attrs: {
        "disabled": _vm.disabled,
        "filter": {
          bundle: false,
          omittedIds: _vm.omittedFamilyIds[index],
        },
        "multiple": ""
      },
      on: {
        "input": _vm.onChange
      },
      model: {
        value: (alternative.requiredFamilies),
        callback: function($$v) {
          alternative.requiredFamilies = $$v
        },
        expression: "alternative.requiredFamilies"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "uk-width-auto"
    }, [_c('common-button', {
      ref: "button",
      refInFor: true,
      attrs: {
        "icon": "trash"
      },
      on: {
        "click": function($event) {
          _vm.removeGroup(index)
        }
      }
    })], 1)])])
  }), _vm._v(" "), _c('common-button', {
    ref: "addGroupButton",
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": _vm.addEmptyGroup
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.addGroup')))])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f6eecfc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductFamilyCompatibilityRequirementAlternativesManager.vue
// module id = 1952
// module chunks = 0